import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createStore(data) {
  return axiosInstance.post(`store/create`, data);
}

export function updateStore(data) {
  return axiosInstance.post(`store/update`, data);
}

export function getStoreList(data) {
  return axiosInstance.post(`store/list`, formatRequest(data));
}

export function getStoreDetails(data) {
  return axiosInstance.post(`store/details`, formatRequest(data));
}

export function deleteOwner(data) {
  return axiosInstance.post(`store/delete`, formatRequest(data));
}

